<template>
    <div>
        <label :for="input.name">
            {{ input.label }}
        </label>
        <input
            class="form-control"

            multiple
            type="file"
            :name="input.name"
            :value="input.value"
            :placeholder="input.placeholder"
            :required="input.validation.includes('required')"
        />
        <input-errors :error-messages="input.errors"></input-errors>
    </div>
</template>

<script>
import common from './common';

export default {
    mixins: [common],
}
</script>
